import React from 'react';
import DirectionsBikeOutlinedIcon from '@mui/icons-material/DirectionsBikeOutlined';

const InvolvedBikerIcon = () => <DirectionsBikeOutlinedIcon />;

export default InvolvedBikerIcon;
